import { Component } from 'react';

import { OnChangeType } from 'types/functions';
import { twclsx } from 'utils/twclsx';

import Icon from './Icon';

interface CheckBoxProps {
    name?: string | number;
    className?: string;
    value: boolean;
    onChange?: OnChangeType;
    disabled?: boolean;
}

interface CheckBoxState {
    value: boolean;
}

class CheckBox extends Component<CheckBoxProps, CheckBoxState> {
    render() {
        const { className, name, value, disabled, onChange } = this.props;

        return (
            <button
                type="button"
                onClick={
                    onChange
                        ? disabled
                            ? () => {
                                  //console.log('Is disabled');
                              }
                            : () => {
                                  onChange(name || '', !value);
                              }
                        : () => {
                              //console.log('No click action');
                          }
                }
                className="cursor-pointer w-4 h-4"
            >
                <Icon className={twclsx('w-4', 'h-4', className)}>
                    <path
                        fill={value ? '#3b82f6' : '#fffff'}
                        d="M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
                    />
                    <path className={twclsx(value ? 'text-white' : 'text-gray-500', className)} d="M9 12l2 2l4 -4" />
                </Icon>
            </button>
        );
    }
}

export default CheckBox;
